import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HoverMask } from '../../common/hover-mask/hover-mask';

@Component({
  selector: 'section[app-home-categoies]',
  imports: [RouterModule, HoverMask],
  templateUrl: './home-categoies.html',
  styleUrl: './home-categoies.scss',
})
export class HomeCategoies {}
